import { InjectionToken, ValueProvider } from '@angular/core';

export type GeographyApiOrigin = { store: string; company: string };
export const GEOGRAPHY_API_ORIGIN = new InjectionToken<GeographyApiOrigin>('Geography API Origin');
export const provideGeographyApiOrigin = (origin: GeographyApiOrigin): ValueProvider => ({
  provide: GEOGRAPHY_API_ORIGIN,
  useValue: origin,
});
